/* eslint-env browser */
import { get, set } from '@firstandthird/cookie-monster';
import Domodule from 'domodule';

class AnnouncementBar extends Domodule {
  postInit() {
    this.cookie = get(this.options.cookie);

    if (!this.cookie && this.isDifferentUrl(this.els.url.href)) {
      this.show();
    }
  }

  /**
   * Remove URL params
   */
  cleanUrl(url) {
    return url.split(/[?#]/)[0].replace(/\/$/, '');
  }

  /**
   * Determines if the current URL differs from the provided one regardless of their params
   */
  isDifferentUrl(url) {
    return this.cleanUrl(window.location.href) !== this.cleanUrl(url);
  }

  show() {
    this.el.setAttribute('aria-hidden', false);
  }

  dismiss() {
    set(this.options.cookie, false);
    this.el.setAttribute('aria-hidden', true);
  }
}

Domodule.register('AnnouncementBar', AnnouncementBar);
